import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { Signup } from 'src/app/models/SignupModels';
import { AuthService } from 'src/app/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, forkJoin, map, of, startWith } from 'rxjs';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import Swal from 'sweetalert2';
import { BreakpointObserver } from '@angular/cdk/layout';
import { OemManagementService } from 'src/app/services/super-admin/oem-management.service';
import { EmailService } from 'src/app/services/email/email.service';
import { ApiResponseModel } from 'src/app/models/shared-model';


@Component({
  selector: 'app-oem-signup',
  templateUrl: './oem-signup.component.html',
  styleUrls: ['./oem-signup.component.css']
})
export class OemSignupComponent {

  OemSignupForm!: FormGroup;
  emailExistsError: string = '';
  OemSignup!: Signup;
  emailSent: boolean = true;
  showError: boolean = false;
  errorMessage = '';
  countryCodes: any[] = [];
  accountType: string ='';
  badRequest: boolean = false;
  selectedPhoneCode: string = '';  
isSignupButtonEnabled: boolean = false;
countrycodes: any[] =[];
countryCode: string | undefined;
filter: any;
  showOptions: boolean | undefined;
  emailInvalid: boolean= false;
  email:string = '';
  validNumber: boolean=true;
  isProceed:boolean=false;
showPassword: boolean = false;
showConfirmPassword: boolean = false;
urlInvalid: boolean = false;
private urlValidationTimeout: any; // Declare timeout variable
@ViewChild('countryCodeInput') countryCodeInput!: ElementRef;
@ViewChild('checkCompanyName') checkCompanyName!: ElementRef;
@ViewChild('checkWebsite') checkWebsite!: ElementRef;
  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private sweetAlertService: SweetAlertService,
     private emailService: EmailService,
    private breakpointObserver: BreakpointObserver, private oemManagementService: OemManagementService,
  ) {
    this.OemSignup = { role: 'OEM', phoneCode: '' } as Signup;
    
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.countryCodeInput && !this.countryCodeInput.nativeElement.contains(event.target)) {
      this.showOptions = false;
    }
  }
  ngOnInit(): void {
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    }else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    this.checkAllBreakPoints();
    this.fetchDropdownData();
  }
  checkAllBreakPoints() {
    this.breakpointObserver.observe([
      '(max-width: 767.98px)'
    ]).subscribe(r => {
      if(r.matches) {
        if(r.breakpoints['(max-width: 767.98px)']) {
          this.resetScrollSettings();
        }
      }
    })
  }
emailExist: boolean = false;
phoneExist: boolean = false;
phoneInvalid: boolean = false;
phoneExistsError: string = '';

onEmailChange(value: string) {
  this.emailInvalid = !this.emailValidation(value);
  if (this.emailInvalid) {
    this.emailExist = false;
    this.emailExistsError = '';
  }
}

onEmailBlur() {
  if (this.OemSignup.email) {
      this.emailInvalid = !this.emailValidation(this.OemSignup.email);
      if (!this.emailInvalid) {
        this.emailService.checkEmailExists(this.OemSignup.email).subscribe({
      next: (response: any) => {
        if (response.exists) {
          this.emailExist = true;
          this.disableOtherFields('email');
        } else {
          this.emailExistsError = '';
          this.emailExist = false;
          this.enableOtherFields();
        }
      },
      error: (error) => {
        if (error.status === 409) {
          this.emailExistsError = 'This Email Address is already in use';
          this.emailExist = true;
          this.disableOtherFields('email');
        } else {
          this.emailExistsError = '';
          this.emailExist = false;
          this.enableOtherFields();
        }
      }
    });
  }
} else {
  this.emailInvalid = false;
  this.emailExistsError = '';
  this.emailExist = false;
  this.enableOtherFields();
}
}

checkPhoneNumberExistence(): void {
  if (this.OemSignup.phoneNumber && !this.phoneInvalid) {
    this.oemManagementService.checkPhoneNumber(this.OemSignup.phoneNumber.toString()).subscribe({
      next: (response: ApiResponseModel<string>) => {
        if (response?.data === 'EXISTS') {
          this.phoneExist = true;
          this.disableOtherFields('phoneNumber');
        } else {
          this.phoneExistsError = '';
          this.phoneExist = false;
          this.enableOtherFields();
        }
      },
      error: (err) => {
        if (err.status === 409) {
          this.phoneExistsError = 'Phone number already exists';
          this.phoneExist = true;
          this.disableOtherFields('phoneNumber');
        } else {
          this.phoneExistsError = '';
          this.phoneExist = false;
          this.enableOtherFields();
        }
      }
    });
  } else {
    this.phoneExistsError = '';
    this.phoneExist = false;
    this.enableOtherFields();
  }
}

private disableOtherFields(exceptField: string): void {
  const fieldsToDisable = [
    'firstName',
    'lastName',
    'email', 
    'companyName',
    'password',
    'confirmPassword',
    'website',
    'phoneCode',
    'phoneNumber',
  ].filter(field => field !== exceptField);

  fieldsToDisable.forEach(field => {
    const element = document.querySelector(`[name="${field}"]`) as HTMLInputElement | HTMLSelectElement;
    if (element) {
      element.disabled = true;
      element.setAttribute('aria-disabled', 'true');
    } else {
      console.warn(`Element with name "${field}" not found`); 
    }
  });
}

private enableOtherFields(): void {
  if (!this.emailExist && !this.phoneExist) { 
    const fieldsToEnable = [
      'firstName',
      'lastName',
      'email', 
      'companyName',
      'password',
      'confirmPassword',
      'website',
      'phoneCode',
      'phoneNumber',
    ];

    fieldsToEnable.forEach(field => {
      const element = document.querySelector(`[name="${field}"]`) as HTMLInputElement | HTMLSelectElement;
      if (element) {
        element.disabled = false;
        element.removeAttribute('aria-disabled'); 
      }
    });
  }
}

  resetScrollSettings(): void {
    setTimeout(() => {
      const body = document.body;
      const html = document.documentElement;

      body.style.overflow = 'auto';
      html.style.overflow = 'auto';
    });
  }
  fetchDropdownData() {
    forkJoin([
      this.authService.getAccounttypes('admin'),
      this.authService.getCountrycodes(0, 300)
    ]).subscribe(
      ([accounttypesResponse, countryCodesResponse]) => {
        this.countrycodes = countryCodesResponse.data;
        const adminAccountType = accounttypesResponse.data.find((account: any) => account.accountType.name === 'admin');
               if (adminAccountType) {
                 this.OemSignup.accountType = adminAccountType.id;;
               } else {
                 
               }
      },
      (error) => {
       
      }
    );
  }
  updateSelectedCountry(event: any) {
    const selectedValue = event.target?.value;
    if (selectedValue) {
      this.selectedPhoneCode = selectedValue;
      this.OemSignup.phoneCode = selectedValue;
    }
  }

  preventCopyPaste(event: Event): void {
    event.preventDefault();
  }
  
  preventContextMenu(event: MouseEvent): void {
    event.preventDefault();
  }
  
  submitForm(form: NgForm) {
    this.isProceed = true;

    if (this.emailExist) {
      this.isProceed = false;
      this.errorMessage = 'Email already exists';
      this.showError = true; 
      return;
    }

    if (this.phoneExist) {
      this.isProceed = false;
      this.errorMessage = 'Phone number already exists';
      this.showError = true;
      return;
    }
    
    if (form.valid && !this.urlInvalid ) { 
      if(!this.isPasswordAndConfirmPasswordMatch(this.OemSignup.password, this.OemSignup.confirmPassword)){
        return;
      }
      this.isProceed = false; 
      
      this.authService.signup(this.OemSignup)
        .subscribe({
          next: (response) => {
            this.emailSent = false;
          },
          error: (error) => {
            this.isProceed = false; 
            if (error.status === 400) {
              this.badRequest = true;
              this.emailSent = true;
              this.errorMessage = error.error.message || 'Invalid data entered.';
            } else {
              this.errorMessage = error.error.message || 'An error occurred while submitting the form.';
            }
            Swal.fire('Error', this.errorMessage ? this.errorMessage : 'An error occurred while submitting the form.', 'warning');
          }
        });
    } else {
      this.showError = true;
      this.errorMessage = 'Please fill out all required fields.';
      this.isProceed = true;
      Swal.fire('Error', 'please fill the all required fields.', 'warning');
    }
  }
  
  passwordValidation(password: string): string[] {
    const errors = [];
    const capitalRegex = /[A-Z]/;
    const smallRegex = /[a-z]/;
    const numberRegex = /[0-9]/;
    const specialCharRegex = /^(?!\s+)(?!.*\s+$)(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;

    if (typeof password !== "undefined" && password != null && password.length > 0) {
        if (password.length < 8 ) {
            errors.push('Password must be at least 8 characters');
        } else if (!capitalRegex.test(password)) {
            errors.push('Password must contain at least one capital letter');
        } else if (!numberRegex.test(password)) {
            errors.push('Password must contain at least one number');
        } else if (!specialCharRegex.test(password)) {
            errors.push('Password must contain at least one special character');
        } else if (!smallRegex.test(password)) {
            errors.push('Password must contain at least one small letter');
        }
    }
    return errors;
}
updateSignupButtonState(event: Event) {
  const target = event.target as HTMLInputElement;
  this.isSignupButtonEnabled = target.checked;
}

filteredCountryCodes: {
  phoneCode: string | undefined; countryCode: string 
}[] = [];
filterOptions(inputValue: string) {  
  if (!inputValue) {
    this.filteredCountryCodes = this.countrycodes;
    return;
  }
  const lowerInput = inputValue.toLowerCase();
  this.filteredCountryCodes = this.countrycodes.filter(code =>
    code.countryCode && code.countryCode.toLowerCase().includes(lowerInput)
  );
  const exactMatch = this.countrycodes.find(code =>
    code.countryCode && code.countryCode.toLowerCase() === lowerInput
  );
  if (exactMatch) {
    this.selectOption(exactMatch);
  }
  else {
    this.showOptions = true; 
  }
}

selectOption(code: any) {
  this.countryCode = code.countryCode; 
  this.OemSignup.phoneCode = code.phoneCode; 
  this.OemSignup.countryCode = code.countryCode;
  this.showOptions = false; 
}
  
emailValidation(email: string): boolean {
  return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email);
}

phonenumbervalidation(phoneNumber: any) { 
  this.validNumber = /^[0-9]+$/.test(phoneNumber) &&phoneNumber.length >= 5 && phoneNumber.length <= 15;}

  resendVerificationMail(): void {
    this.authService.resendVerificationEmail(this.OemSignup.email)
      .subscribe(
        (response) => {
          if (response && response.status === 'OK') {
            this.sweetAlertService.showSuccess('Email Sent', 'Verification Email Sent');
          } else {
            this.sweetAlertService.showError('Error', 'Error Sending Verification Email');
          }
        }
      );
  }

  isValidUrl(url: string): boolean {
    const urlPattern = /^(https?:\/\/)?([\w.-]+\.[a-z]{2,6})(\/[\w.-]*)*(\#[\w.-]*)?(\?[\/\w&%=.-]*)?$/i;
    return urlPattern.test(url);
  }

  validateUrl(event: any): void {
    clearTimeout(this.urlValidationTimeout); 
  
    this.urlValidationTimeout = setTimeout(() => {
      const inputElement = event.target as HTMLInputElement;
      let url = inputElement.value.trim().toLowerCase();
      this.urlInvalid = !!(url && !this.isValidUrl(url));
    }, 300);
  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  onlyText(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || 
        (charCode >= 65 && charCode <= 90) || 
        (charCode >= 97 && charCode <= 122) ) { 
      return true;
    }
    return false;
  }
    onlyText2(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    if ( 
        (charCode >= 65 && charCode <= 90) || 
        (charCode >= 97 && charCode <= 122)) {
      return true;
    }
    return false;
  }
  onlyText3(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || 
        (charCode >= 65 && charCode <= 90) || 
        (charCode >= 97 && charCode <= 122) ||
      charCode === 32) {
      return true;
    }
    return false;
  }

alreadyExistedCompanyName: string = '';
  editedCompanyName: string = '';
  alreadyChecked=false;
  isCompanyInputField: boolean = false;
  isSwalConfirmed: boolean = false;
  isHandlingFocus: boolean = false; 

  isFocusOff(event: any) {
    if(event.target.value === '') {
      this.alreadyChecked = false;
      return;
    }
    
    if(!this.alreadyChecked) {
      this.oemManagementService.checkCompanyName(event.target.value).subscribe(res => {
      },
      error => {
        if (error.status === 409) {
          this.swalPopupAppeared(event);
          this.alreadyChecked = false;
          this.alreadyExistedCompanyName = event.target.value;
        } else {
        }
      }
    )
    }
  }

  swalPopupAppeared(event: any){
    Swal.fire({
      position : 'center',
      title: 'Warning',
      text: 'Company name already exists. Do you still want to continue?',
      iconHtml: '<img src="./assets/images/group-delete.svg">',
      iconColor : 'white',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Yes',
      confirmButtonColor : '#0f74a9',
      cancelButtonText: 'No',  
      cancelButtonColor : '#6c757d',
    }).then((result) => {
      if (result.isConfirmed) {
        this.isCompanyInputField = false;
        this.isFocusOn(event);
      } else if(result.isDismissed) {
        this.isCompanyInputField = true;
        this.isFocusOut(event);
      }
    })
  }

  isFocusOut(event: any){
    if (this.isHandlingFocus) return; 
    if(this.isCompanyInputField) {
      this.isHandlingFocus = true;
      if(this.checkCompanyName){
        this.checkCompanyName.nativeElement.focus();
      }
      this.isHandlingFocus = false;
    }
  }
  editEvent(){
    this.isSwalConfirmed = false;
    if(this.alreadyChecked && this.isSwalConfirmed === false) {
     if(this.checkCompanyName){
      this.checkCompanyName.nativeElement.focus();
     }

    }
  }
  isFocusOn(event: any) {
    if (this.isHandlingFocus) return;

    if(this.isSwalConfirmed && this.alreadyChecked) {
      this.isHandlingFocus = true;

      if(this.checkCompanyName){
        this.checkCompanyName.nativeElement.blur();
      }
      if(this.checkWebsite){
        this.checkWebsite.nativeElement.focus();
      }
      this.isHandlingFocus = false;
    }
  }
  isInputChange(event: any) {
    this.alreadyChecked = false;
    this.isSwalConfirmed = false;
    this.isCompanyInputField = false;
    
    if(event.target.value === '') {
    }
     else if(this.OemSignup.companyName !== this.alreadyExistedCompanyName){
      this.isCompanyInputField = false;
      this.isFocusOut(event);
    } else if(this.OemSignup.companyName === this.alreadyExistedCompanyName){
      this.alreadyExistedCompanyName = this.OemSignup.companyName || '';
      
      this.alreadyChecked = true;
      this.isSwalConfirmed = true;
      this.swalPopupAppeared(event);
    }
  }
  
  isPasswordAndConfirmPasswordMatch(password: string, confirmPassword: string): boolean {
    if(password !== '' && confirmPassword !== '') {
      return password === confirmPassword;
    } 
    return false;
  }
}
